
/**
 * Exploration phase analysis utilities
 */

export function analyzeExplorationPhase(projectData: any, marketData: any): any {
  return {
    phaseSpecificMetrics: {
      drillingProgress: projectData.drillingMeters || 0,
      resourceConfidence: calculateResourceConfidence(projectData),
      gradeQuality: assessGradeQuality(projectData),
      metallurgyResults: projectData.metallurgyScore || 0
    },
    riskProfile: {
      geologicalRisk: 65, // Reduced from prospecting
      politicalRisk: 35,
      technicalRisk: 45,
      marketRisk: 55,
      overallRisk: 50
    },
    valueDrivers: [
      { name: 'Resource Size', weight: 35, score: 65 },
      { name: 'Resource Grade', weight: 30, score: 60 },
      { name: 'Metallurgy', weight: 20, score: 55 },
      { name: 'Infrastructure', weight: 15, score: 70 }
    ],
    milestoneProjections: [
      {
        name: 'Resource Estimate',
        timeframe: '6-12 months',
        probability: 75,
        valueImpact: 40
      },
      {
        name: 'PEA Completion',
        timeframe: '12-18 months',
        probability: 60,
        valueImpact: 25
      }
    ],
    fundingRequirements: {
      nextPhase: 2000000,
      totalToProduction: 45000000,
      riskAdjustedNPV: 5000000
    },
    probabilityOfSuccess: 45
  };
}

function calculateResourceConfidence(projectData: any): number {
  return Math.min(100, (projectData.resourceConfidence || 40) + Math.random() * 30);
}

function assessGradeQuality(projectData: any): number {
  return Math.min(100, (projectData.gradeQuality || 55) + Math.random() * 25);
}
